// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/generation_sales_plan_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { PlanSubmissionStatus, PlanTimeframe } from "../../bfftypes/v1/plan_submission_pb";
import { file_bfftypes_v1_plan_submission } from "../../bfftypes/v1/plan_submission_pb";
import type { GenerationSalesPlanDetail, GenerationSalesPlanRow, GenerationSalesPlanTab } from "./generation_sales_plan_model_pb";
import { file_bffuser_v1_generation_sales_plan_model } from "./generation_sales_plan_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/generation_sales_plan_service.proto.
 */
export const file_bffuser_v1_generation_sales_plan_service: GenFile = /*@__PURE__*/
  fileDesc("Ci5iZmZ1c2VyL3YxL2dlbmVyYXRpb25fc2FsZXNfcGxhbl9zZXJ2aWNlLnByb3RvEgpiZmZ1c2VyLnYxIq0CCh9MaXN0R2VuZXJhdGlvblNhbGVzUGxhbnNSZXF1ZXN0EjkKCXRpbWVmcmFtZRgBIAEoDjIaLmJmZnR5cGVzLnYxLlBsYW5UaW1lZnJhbWVCCrpIB4IBBBABIAASOwoYdGFyZ2V0X3BlcmlvZF9zdGFydF9kYXRlGAIgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUIGukgDyAEBEjIKCWFyZWFfY29kZRgDIAEoDjIVLmJmZnR5cGVzLnYxLkFyZWFDb2RlQgi6SAWCAQIQARIcChRpbmNsdWRlX2FsbF92ZXJzaW9ucxgEIAEoCBJACghwbGFuX3RhYhgFIAEoDjIiLmJmZnVzZXIudjEuR2VuZXJhdGlvblNhbGVzUGxhblRhYkIKukgHggEEEAEgACKAAQogTGlzdEdlbmVyYXRpb25TYWxlc1BsYW5zUmVzcG9uc2USMAoEcm93cxgBIAMoCzIiLmJmZnVzZXIudjEuR2VuZXJhdGlvblNhbGVzUGxhblJvdxIUCgxoYXNfZml0X3BsYW4YAiABKAgSFAoMaGFzX2ZpcF9wbGFuGAMgASgIIk0KJURvd25sb2FkR2VuZXJhdGlvblNhbGVzUGxhblhtbFJlcXVlc3QSJAoScGxhbl9zdWJtaXNzaW9uX2lkGAEgASgJQgi6SAVyA7ABASJiCiZEb3dubG9hZEdlbmVyYXRpb25TYWxlc1BsYW5YbWxSZXNwb25zZRIPCgdjb250ZW50GAEgASgMEhEKCWZpbGVfbmFtZRgCIAEoCRIUCgxjb250ZW50X3R5cGUYAyABKAkiOwojR2V0R2VuZXJhdGlvblNhbGVzUGxhbkRldGFpbFJlcXVlc3QSFAoCaWQYASABKAlCCLpIBXIDsAEBIl0KJEdldEdlbmVyYXRpb25TYWxlc1BsYW5EZXRhaWxSZXNwb25zZRI1CgZkZXRhaWwYASABKAsyJS5iZmZ1c2VyLnYxLkdlbmVyYXRpb25TYWxlc1BsYW5EZXRhaWwiOAogU3VibWl0R2VuZXJhdGlvblNhbGVzUGxhblJlcXVlc3QSFAoCaWQYASABKAlCCLpIBXIDsAEBIsoBCiFTdWJtaXRHZW5lcmF0aW9uU2FsZXNQbGFuUmVzcG9uc2USMQoGc3RhdHVzGAEgASgOMiEuYmZmdHlwZXMudjEuUGxhblN1Ym1pc3Npb25TdGF0dXMSNQoMc3VibWl0dGVkX2F0GAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgAiAEBEhkKDGVycm9yX3JlYXNvbhgDIAEoCUgBiAEBQg8KDV9zdWJtaXR0ZWRfYXRCDwoNX2Vycm9yX3JlYXNvbiL5AQogQ3JlYXRlR2VuZXJhdGlvblNhbGVzUGxhblJlcXVlc3QSOQoJdGltZWZyYW1lGAEgASgOMhouYmZmdHlwZXMudjEuUGxhblRpbWVmcmFtZUIKukgHggEEEAEgABI0CglhcmVhX2NvZGUYAiABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZUIKukgHggEEEAEgABI7Chh0YXJnZXRfcGVyaW9kX3N0YXJ0X2RhdGUYAyABKAsyES5nb29nbGUudHlwZS5EYXRlQga6SAPIAQESJwoWc3VibWlzc2lvbl9lbnRpdHlfY29kZRgEIAEoCUIHukgEcgIQASJiCiFDcmVhdGVHZW5lcmF0aW9uU2FsZXNQbGFuUmVzcG9uc2USCgoCaWQYASABKAkSMQoGc3RhdHVzGAIgASgOMiEuYmZmdHlwZXMudjEuUGxhblN1Ym1pc3Npb25TdGF0dXMynwUKGkdlbmVyYXRpb25TYWxlc1BsYW5TZXJ2aWNlEncKGExpc3RHZW5lcmF0aW9uU2FsZXNQbGFucxIrLmJmZnVzZXIudjEuTGlzdEdlbmVyYXRpb25TYWxlc1BsYW5zUmVxdWVzdBosLmJmZnVzZXIudjEuTGlzdEdlbmVyYXRpb25TYWxlc1BsYW5zUmVzcG9uc2UiABKJAQoeRG93bmxvYWRHZW5lcmF0aW9uU2FsZXNQbGFuWG1sEjEuYmZmdXNlci52MS5Eb3dubG9hZEdlbmVyYXRpb25TYWxlc1BsYW5YbWxSZXF1ZXN0GjIuYmZmdXNlci52MS5Eb3dubG9hZEdlbmVyYXRpb25TYWxlc1BsYW5YbWxSZXNwb25zZSIAEoMBChxHZXRHZW5lcmF0aW9uU2FsZXNQbGFuRGV0YWlsEi8uYmZmdXNlci52MS5HZXRHZW5lcmF0aW9uU2FsZXNQbGFuRGV0YWlsUmVxdWVzdBowLmJmZnVzZXIudjEuR2V0R2VuZXJhdGlvblNhbGVzUGxhbkRldGFpbFJlc3BvbnNlIgASegoZU3VibWl0R2VuZXJhdGlvblNhbGVzUGxhbhIsLmJmZnVzZXIudjEuU3VibWl0R2VuZXJhdGlvblNhbGVzUGxhblJlcXVlc3QaLS5iZmZ1c2VyLnYxLlN1Ym1pdEdlbmVyYXRpb25TYWxlc1BsYW5SZXNwb25zZSIAEnoKGUNyZWF0ZUdlbmVyYXRpb25TYWxlc1BsYW4SLC5iZmZ1c2VyLnYxLkNyZWF0ZUdlbmVyYXRpb25TYWxlc1BsYW5SZXF1ZXN0Gi0uYmZmdXNlci52MS5DcmVhdGVHZW5lcmF0aW9uU2FsZXNQbGFuUmVzcG9uc2UiAEJAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bfftypes_v1_area, file_bfftypes_v1_plan_submission, file_bffuser_v1_generation_sales_plan_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * ListGenerationSalesPlansRequest carries filtering criteria for the list.
 *
 * @generated from message bffuser.v1.ListGenerationSalesPlansRequest
 */
export type ListGenerationSalesPlansRequest = Message<"bffuser.v1.ListGenerationSalesPlansRequest"> & {
  /**
   * Planning horizon to filter by. UNSPECIFIED is rejected.
   *
   * @generated from field: bfftypes.v1.PlanTimeframe timeframe = 1;
   */
  timeframe: PlanTimeframe;

  /**
   * Start date of the target period to filter by.
   *
   * @generated from field: google.type.Date target_period_start_date = 2;
   */
  targetPeriodStartDate?: Date;

  /**
   * Optional area filter. When absent (= UNSPECIFIED), all areas are
   * returned. UNSPECIFIED (= 0) is accepted as "no filter".
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * When false (= default / zero value), only the latest version of each
   * submission is returned. When true, all versions are returned.
   *
   * @generated from field: bool include_all_versions = 4;
   */
  includeAllVersions: boolean;

  /**
   * Plan sub-kind tab to filter by (発電販売 / FIT / FIP). UNSPECIFIED is
   * rejected; callers must supply an explicit tab.
   *
   * @generated from field: bffuser.v1.GenerationSalesPlanTab plan_tab = 5;
   */
  planTab: GenerationSalesPlanTab;
};

/**
 * Describes the message bffuser.v1.ListGenerationSalesPlansRequest.
 * Use `create(ListGenerationSalesPlansRequestSchema)` to create a new message.
 */
export const ListGenerationSalesPlansRequestSchema: GenMessage<ListGenerationSalesPlansRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_generation_sales_plan_service, 0);

/**
 * @generated from message bffuser.v1.ListGenerationSalesPlansResponse
 */
export type ListGenerationSalesPlansResponse = Message<"bffuser.v1.ListGenerationSalesPlansResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.GenerationSalesPlanRow rows = 1;
   */
  rows: GenerationSalesPlanRow[];

  /**
   * Whether FIT plan submissions exist for the given filters (used to
   * conditionally render the FIT tab in the UI).
   *
   * @generated from field: bool has_fit_plan = 2;
   */
  hasFitPlan: boolean;

  /**
   * Whether FIP plan submissions exist for the given filters (used to
   * conditionally render the FIP tab in the UI).
   *
   * @generated from field: bool has_fip_plan = 3;
   */
  hasFipPlan: boolean;
};

/**
 * Describes the message bffuser.v1.ListGenerationSalesPlansResponse.
 * Use `create(ListGenerationSalesPlansResponseSchema)` to create a new message.
 */
export const ListGenerationSalesPlansResponseSchema: GenMessage<ListGenerationSalesPlansResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_generation_sales_plan_service, 1);

/**
 * DownloadGenerationSalesPlanXmlRequest specifies the plan submission whose
 * XML archive should be retrieved.
 *
 * @generated from message bffuser.v1.DownloadGenerationSalesPlanXmlRequest
 */
export type DownloadGenerationSalesPlanXmlRequest = Message<"bffuser.v1.DownloadGenerationSalesPlanXmlRequest"> & {
  /**
   * UUID surrogate primary key of the plan submission to download.
   *
   * @generated from field: string plan_submission_id = 1;
   */
  planSubmissionId: string;
};

/**
 * Describes the message bffuser.v1.DownloadGenerationSalesPlanXmlRequest.
 * Use `create(DownloadGenerationSalesPlanXmlRequestSchema)` to create a new message.
 */
export const DownloadGenerationSalesPlanXmlRequestSchema: GenMessage<DownloadGenerationSalesPlanXmlRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_generation_sales_plan_service, 2);

/**
 * @generated from message bffuser.v1.DownloadGenerationSalesPlanXmlResponse
 */
export type DownloadGenerationSalesPlanXmlResponse = Message<"bffuser.v1.DownloadGenerationSalesPlanXmlResponse"> & {
  /**
   * Raw bytes of the plan XML (OCCTO BP-規格 format).
   *
   * @generated from field: bytes content = 1;
   */
  content: Uint8Array;

  /**
   * OCCTO BP-規格ファイル名 (e.g. "W6_0250_20260602_00_47633_3.xml").
   *
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * MIME type of the content (= "application/xml").
   *
   * @generated from field: string content_type = 3;
   */
  contentType: string;
};

/**
 * Describes the message bffuser.v1.DownloadGenerationSalesPlanXmlResponse.
 * Use `create(DownloadGenerationSalesPlanXmlResponseSchema)` to create a new message.
 */
export const DownloadGenerationSalesPlanXmlResponseSchema: GenMessage<DownloadGenerationSalesPlanXmlResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_generation_sales_plan_service, 3);

/**
 * GetGenerationSalesPlanDetailRequest specifies the plan submission whose
 * detail should be fetched.
 *
 * @generated from message bffuser.v1.GetGenerationSalesPlanDetailRequest
 */
export type GetGenerationSalesPlanDetailRequest = Message<"bffuser.v1.GetGenerationSalesPlanDetailRequest"> & {
  /**
   * UUID surrogate primary key of the plan submission to fetch.
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetGenerationSalesPlanDetailRequest.
 * Use `create(GetGenerationSalesPlanDetailRequestSchema)` to create a new message.
 */
export const GetGenerationSalesPlanDetailRequestSchema: GenMessage<GetGenerationSalesPlanDetailRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_generation_sales_plan_service, 4);

/**
 * @generated from message bffuser.v1.GetGenerationSalesPlanDetailResponse
 */
export type GetGenerationSalesPlanDetailResponse = Message<"bffuser.v1.GetGenerationSalesPlanDetailResponse"> & {
  /**
   * @generated from field: bffuser.v1.GenerationSalesPlanDetail detail = 1;
   */
  detail?: GenerationSalesPlanDetail;
};

/**
 * Describes the message bffuser.v1.GetGenerationSalesPlanDetailResponse.
 * Use `create(GetGenerationSalesPlanDetailResponseSchema)` to create a new message.
 */
export const GetGenerationSalesPlanDetailResponseSchema: GenMessage<GetGenerationSalesPlanDetailResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_generation_sales_plan_service, 5);

/**
 * SubmitGenerationSalesPlanRequest specifies the plan submission to submit
 * to the OCCTO portal.
 *
 * @generated from message bffuser.v1.SubmitGenerationSalesPlanRequest
 */
export type SubmitGenerationSalesPlanRequest = Message<"bffuser.v1.SubmitGenerationSalesPlanRequest"> & {
  /**
   * UUID surrogate primary key of the plan submission to submit.
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.SubmitGenerationSalesPlanRequest.
 * Use `create(SubmitGenerationSalesPlanRequestSchema)` to create a new message.
 */
export const SubmitGenerationSalesPlanRequestSchema: GenMessage<SubmitGenerationSalesPlanRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_generation_sales_plan_service, 6);

/**
 * @generated from message bffuser.v1.SubmitGenerationSalesPlanResponse
 */
export type SubmitGenerationSalesPlanResponse = Message<"bffuser.v1.SubmitGenerationSalesPlanResponse"> & {
  /**
   * Status of the submission immediately after the submit attempt (=
   * SUBMITTED on success, or a failure status on error).
   *
   * @generated from field: bfftypes.v1.PlanSubmissionStatus status = 1;
   */
  status: PlanSubmissionStatus;

  /**
   * Timestamp at which the plan was submitted to the OCCTO portal. Absent
   * when the submit attempt failed.
   *
   * @generated from field: optional google.protobuf.Timestamp submitted_at = 2;
   */
  submittedAt?: Timestamp;

  /**
   * Failure detail when the submit attempt did not succeed. Absent on
   * success.
   *
   * @generated from field: optional string error_reason = 3;
   */
  errorReason?: string;
};

/**
 * Describes the message bffuser.v1.SubmitGenerationSalesPlanResponse.
 * Use `create(SubmitGenerationSalesPlanResponseSchema)` to create a new message.
 */
export const SubmitGenerationSalesPlanResponseSchema: GenMessage<SubmitGenerationSalesPlanResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_generation_sales_plan_service, 7);

/**
 * CreateGenerationSalesPlanRequest triggers creation of a new generation-sales
 * plan submission. All enum fields reject UNSPECIFIED (= 0).
 *
 * @generated from message bffuser.v1.CreateGenerationSalesPlanRequest
 */
export type CreateGenerationSalesPlanRequest = Message<"bffuser.v1.CreateGenerationSalesPlanRequest"> & {
  /**
   * Planning horizon for this submission.
   *
   * @generated from field: bfftypes.v1.PlanTimeframe timeframe = 1;
   */
  timeframe: PlanTimeframe;

  /**
   * Supply area this submission is bound to.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * Start date of the target period covered by this submission.
   *
   * @generated from field: google.type.Date target_period_start_date = 3;
   */
  targetPeriodStartDate?: Date;

  /**
   * OCCTO BG code of the submission entity (balancing group).
   *
   * @generated from field: string submission_entity_code = 4;
   */
  submissionEntityCode: string;
};

/**
 * Describes the message bffuser.v1.CreateGenerationSalesPlanRequest.
 * Use `create(CreateGenerationSalesPlanRequestSchema)` to create a new message.
 */
export const CreateGenerationSalesPlanRequestSchema: GenMessage<CreateGenerationSalesPlanRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_generation_sales_plan_service, 8);

/**
 * @generated from message bffuser.v1.CreateGenerationSalesPlanResponse
 */
export type CreateGenerationSalesPlanResponse = Message<"bffuser.v1.CreateGenerationSalesPlanResponse"> & {
  /**
   * UUID surrogate primary key of the newly created plan submission.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Status of the submission immediately after creation (= GENERATING).
   * The backend worker transitions this to GENERATED once assembly is complete.
   *
   * @generated from field: bfftypes.v1.PlanSubmissionStatus status = 2;
   */
  status: PlanSubmissionStatus;
};

/**
 * Describes the message bffuser.v1.CreateGenerationSalesPlanResponse.
 * Use `create(CreateGenerationSalesPlanResponseSchema)` to create a new message.
 */
export const CreateGenerationSalesPlanResponseSchema: GenMessage<CreateGenerationSalesPlanResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_generation_sales_plan_service, 9);

/**
 * GenerationSalesPlanService provides Connect RPCs for the 発電販売計画一覧
 * (generation-sales plan list) screen consumed by the frontend.
 *
 * @generated from service bffuser.v1.GenerationSalesPlanService
 */
export const GenerationSalesPlanService: GenService<{
  /**
   * ListGenerationSalesPlans returns the generation-sales plan list-screen
   * rows for the authenticated organization. When include_all_versions is
   * false (= default / zero value), only the latest version of each
   * submission is returned.
   *
   * @generated from rpc bffuser.v1.GenerationSalesPlanService.ListGenerationSalesPlans
   */
  listGenerationSalesPlans: {
    methodKind: "unary";
    input: typeof ListGenerationSalesPlansRequestSchema;
    output: typeof ListGenerationSalesPlansResponseSchema;
  },
  /**
   * DownloadGenerationSalesPlanXml returns the plan XML content and its
   * OCCTO BP-規格ファイル名 for the specified plan submission. The BFF
   * handler resolves organization_id from the eauth session.
   *
   * @generated from rpc bffuser.v1.GenerationSalesPlanService.DownloadGenerationSalesPlanXml
   */
  downloadGenerationSalesPlanXml: {
    methodKind: "unary";
    input: typeof DownloadGenerationSalesPlanXmlRequestSchema;
    output: typeof DownloadGenerationSalesPlanXmlResponseSchema;
  },
  /**
   * GetGenerationSalesPlanDetail returns the full detail of a single
   * generation-sales plan submission, including per-BG generation values,
   * sales / procurement breakdown rows, and the previous submitted version
   * for diff display. All data is returned in a single RPC to minimise
   * round-trips. The BFF handler resolves organization_id from the eauth
   * session.
   *
   * @generated from rpc bffuser.v1.GenerationSalesPlanService.GetGenerationSalesPlanDetail
   */
  getGenerationSalesPlanDetail: {
    methodKind: "unary";
    input: typeof GetGenerationSalesPlanDetailRequestSchema;
    output: typeof GetGenerationSalesPlanDetailResponseSchema;
  },
  /**
   * SubmitGenerationSalesPlan submits a generated generation-sales plan
   * submission to the OCCTO portal. On success the status transitions to
   * SUBMITTED and submitted_at is populated. The BFF handler resolves
   * organization_id from the eauth session.
   *
   * @generated from rpc bffuser.v1.GenerationSalesPlanService.SubmitGenerationSalesPlan
   */
  submitGenerationSalesPlan: {
    methodKind: "unary";
    input: typeof SubmitGenerationSalesPlanRequestSchema;
    output: typeof SubmitGenerationSalesPlanResponseSchema;
  },
  /**
   * CreateGenerationSalesPlan triggers the creation of a new generation-sales
   * plan submission. The backend enqueues a plan generation outbox entry and
   * returns the new submission id with status GENERATING. The worker assembles
   * the plan values asynchronously. kind is fixed to GENERATION_SALE by the
   * BFF handler.
   *
   * @generated from rpc bffuser.v1.GenerationSalesPlanService.CreateGenerationSalesPlan
   */
  createGenerationSalesPlan: {
    methodKind: "unary";
    input: typeof CreateGenerationSalesPlanRequestSchema;
    output: typeof CreateGenerationSalesPlanResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_generation_sales_plan_service, 0);

